import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { reportError } from '@/domains/observability'

import { cancelInvoice } from './api'
import { useInvalidateInvoices } from './use-invalidate-invoices'

export function useCancelInvoice() {
  const invalidate = useInvalidateInvoices()
  return useMutation({
    mutationFn: (id: string) => cancelInvoice(id),
    onSuccess: invoice => {
      invalidate(invoice.id)
      toast.success(`Invoice ${invoice.invoiceNumber} cancelled`)
    },
    onError: error => {
      reportError(error)
      toast.error('Failed to cancel invoice')
    }
  })
}
